import { sendTestMatomoEvent } from "./matomoTest";



// Helper function to format seconds into HH:MM:SS
  function formatSecondsToHMS(seconds) {
    const hrs = Math.floor(seconds / 3600)
      .toString()
      .padStart(2, "0");
    const mins = Math.floor((seconds % 3600) / 60)
      .toString()
      .padStart(2, "0");
    const secs = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  }



  // Function to handle Play/Pause Matomo events for Audio content
export const handleMotamoPlayPauseEvent = ({eventActionName, videoRef, itemDetails, itemData, trackData, currentIndex, sourceContext}) => {

  // console.log(eventActionName, videoRef, itemDetails, itemData, trackData, currentIndex, sourceContext, "checkingAudioPLayPauseEvent");
    const video = videoRef.current;
    const seconds = Math.floor(video.currentTime);
    const timeLabel = formatSecondsToHMS(seconds);
    const audioType = itemDetails?.[0]?.category_title;
    const itemId = itemData?.id || "";
    const itemTitle = itemData?.title || "";
    // console.log(audioType, eventActionName,timeLabel, "audioType11", "itemDetails");

    let eventCategory = "";
    let eventAction = eventActionName;
    let eventName = "";

    // Aod is missing

    switch (audioType) {
      case "Radio Channels":
        eventCategory = "LiveRadio";
        eventName = `${itemId}/${itemTitle}`;
        break;

      case "Audio":
        eventCategory = "Audio";
        eventName = `${trackData[currentIndex]?.id}/${itemTitle}/${trackData[currentIndex]?.title}(AOD)/${timeLabel}`;
        break;
    }

    sendTestMatomoEvent({
      eventCategory,
      eventAction,
      eventName,
      sourceContext: sourceContext || "",
    });

    if (audioType === "Radio Channels") {
      sendRadioChannelEvent({
        actionType: eventActionName,
        itemData,
        itemDetails,
      });
    }
  };



  // Function to send Matomo events for Radio Channels
  export const sendRadioChannelEvent = async ({
    actionType, // Play, Pause, Resume, Stop
    itemData,
    itemDetails,
  }) => {
    const genres = itemDetails?.[0]?.genres;
    const actionName = genres
      ? `${itemData?.id}/${itemData?.title} - ${genres}`
      : `${itemData?.id}/${itemData?.title}`;
    const ciValue = `LiveRadio/${actionType}`;

    // Interaction
    await sendTestMatomoEvent(
      {
        action_name: actionName,
      },
      {
        eventType: "content_interaction",
        c_i: ciValue,
      }
    );

    // Impression
    await sendTestMatomoEvent(
      {
        action_name: actionName,
      },
      {
        eventType: "content_impression",
      }
    );

    console.log(`Matomo ${actionType} event sent for RadioChannel`);
  };




  // Function to send Matomo events for Audio Watchlist actions

   export const sendAudioWatchListEvent = async ({
      actionType, // Play, Pause, Resume, Stop
      itemData,
      itemDetails,
    }) => {
      const genres = itemDetails?.[0]?.genres;
      const actionName = `${itemData?.id}/${itemData?.title}-${genres}`
      const ciValue = `Watchlist/${actionType}`;
  
      // Event 
      await sendTestMatomoEvent({
        eventCategory: "Watchlist",
        eventAction:actionType,
        eventName: `${itemData?.id}/${itemData?.title}`,
  
      })  
  
      // Interaction
      await sendTestMatomoEvent(
        {
          action_name: actionName,
        },
        {
          eventType: "content_interaction",
          c_i: ciValue,
        }
      );
  
      // Impression
      await sendTestMatomoEvent(
        {
          action_name: actionName,
        },
        {
          eventType: "content_impression",
        }
      );
      console.log(`Matomo ${actionType} event sent for LiveChannel`);
    };


    // Function to send media playback heartbeat for Audio
    export const mediaPlaybackMotamoEvent = async ({
      videoRef,
      itemDetails,
      itemData,
      trackData,
      currentIndex,
      DrmInformatin,
      GetVideoUrlData,
      mediaIdRef,
    }) => {

      const videoElement = videoRef?.current;
      if (!videoElement) {
        // Video element not ready
        return;
      }


      // DON'T send heartbeat when paused or ad is playing
      if (videoElement.paused) {
        return;
      }

      const currentTime = videoElement.currentTime;
      const duration = videoElement.duration;



      if (!currentTime || !duration || !mediaIdRef?.current) {
        return;
      }

      const itemTitle = itemDetails?.[0].title || itemData?.season || "";



      const isRadioChannel =
        itemDetails?.[0]?.category_title === "Radio Channels";

      await sendTestMatomoEvent(
        { action_name: `audio_play` },
        {
          eventType: "media_action",
          mediaLength: isRadioChannel ? 0 : parseInt(duration),
          mediaId: mediaIdRef.current,
          mediaUrl:
            DrmInformatin?.data?.file_url || GetVideoUrlData?.[0]?.file_url || "-",
          mediaType: "Audio",
          mediaTitle: isRadioChannel
            ? `${itemData?.id}/${itemData?.title}`
            : `${trackData[currentIndex]?.id}/${itemTitle}-${trackData[currentIndex]?.title}`,
          mediaPlayer: "html5video",
          mediaInSecond: parseInt(currentTime),
          mediaPlaytime: parseInt(currentTime),
          mediaProgress: parseInt(currentTime),
        }
      );
    };